<template>
    <div style="position: relative;z-index:3;left:0px;border-bottom: 1px solid #e8eaec" :id="!isjxt?'funcmenu':'funcmenu2'">
        <Menu @on-select="onMenuSelect" mode="horizontal" :theme="theme1" :active-name="actname" style="height:40px;line-height:40px;" class="Menu">
            <MenuItem name="1">
            <!--    <Icon type="md-home" :size="iconsize" /> -->
            <span :class="actname==='1'?'activeMenu':'normalMenu'">政策法规</span>
            </MenuItem>
            <MenuItem name="8" :style="{display:!isShowMoreMenu?'block':'none'}">
            <span :class="actname==='8'?'activeMenu':'normalMenu'">官方解答</span>
            </MenuItem>
            <MenuItem name="7" v-show="!isjxt">
            <span :class="actname==='7'?'activeMenu':'normalMenu'">搜索引擎</span>
            </MenuItem>
            <MenuItem name="15" v-show="!isjxt">
            <span :class="actname==='15'?'activeMenu':'normalMenu'"><div class="fxjc">财税体检</div></span>
            </MenuItem>
            <!-- <MenuItem name="14" :style="{display:this.$baseConfig.test.includes(sta.userId) ||  this.$baseConfig.test==[]?'block':'none'}"> -->
            <MenuItem name="14" v-show="!isjxt">
            <span :class="actname==='14'?'activeMenu':'normalMenu'"><font>AI问答</font></span>
            </MenuItem>
            <MenuItem :style="{display:!isShowMoreMenu?'block':'none'}" name="9">
            <span :class="actname==='9'?'activeMenu':'normalMenu'">
                 涉税判例
                <!-- <Tooltip content="涉税判例升级维护中 ···" theme="dark">
                涉税判例<span :class="actname==='9'?'activeChildMenu':'normalChildMenu'">（维护中）</span>
                </Tooltip> -->
            </span>
            </MenuItem>
            
            <MenuItem name="10" :style="{display:!isShowMoreMenu?'block':'none'}">
            <span  :class="actname==='10'?'activeMenu':'normalMenu'">税务案例</span>
            </MenuItem>
            <!-- <MenuItem name="13" :style="{display:!isShowMoreMenu?'block':'none'}">
            <span  :class="actname==='13'?'activeMenu':'normalMenu'">专家解读</span>
            </MenuItem> -->
            <Submenu name="2" style="color:#808695" v-show="!isjxt">
                <template slot="title">
                    <!-- <Icon type="ios-cloud" :size="iconsize" /> -->
                    <span :class="actname==='2-1'?'activeMenu':'normalMenu'">智慧云端</span>
                </template>
                <MenuGroup title="使用">
                    <MenuItem name="2-1">
                    <!-- <router-link to="/main/cloud/mycloud?q_type=mycloud">上传文件库</router-link> -->
                    <router-link to="/mycloud?q_type=mycloud">上传文件库</router-link>
                    </MenuItem>
                    <!-- <MenuItem name="2-2">
          <router-link to="/mycloud?q_type=mydoc">我的工作薄</router-link>
          </MenuItem> -->
                </MenuGroup>
            </Submenu>
            <Submenu name="3" :style="{display:!isShowMoreMenu?'block':'none'}" style="color:#808695" v-if="!isjxt">
                <template slot="title">
                    <!-- <Icon type="ios-briefcase" :size="iconsize" /> -->
                    <span :class="actname==='3-1' || actname==='3-2'?'activeMenu':'normalMenu'">我的秘书</span>
                    <!-- <Badge :count="10"></Badge> -->
                </template>
                <MenuGroup title="变动">
                    <MenuItem name="3-1">
                    <!-- <router-link to="/main/assistant/myassistant?q_type=cloudmsg">云端变动提醒</router-link> -->
                    <router-link to="/myassistant?q_type=cloudmsg">文件提醒</router-link>
                    <!--  <Badge :count="10"></Badge> -->
                    </MenuItem>
                </MenuGroup>
                <MenuGroup title="记录">
                    <MenuItem name="3-2">
                    <router-link to="/myassistant?q_type=cloudhistory">查询记录</router-link>
                    </MenuItem>
                </MenuGroup>
            </Submenu>
            <MenuItem v-if="!isjxt" :style="{display:!isShowMoreMenu?'block':'none'}" name="11">
            <span :class="actname==='11'?'activeMenu':'normalMenu'">涉税表单</span>
            </MenuItem>
            
            <MenuItem v-if="!isjxt" :style="{display:!isShowMoreMenu?'block':'none'}" name="12">
            <span :class="actname==='12'?'activeMenu':'normalMenu'">优惠匹配</span>
            </MenuItem>
            <MenuItem name="4" v-show="!isjxt">
            <span :class="actname==='4'?'activeMenu':'normalMenu'">在线商城</span>
            <!--  <router-link to="/userstore" :style="{display:(sta.accounttype===1 || sta.accounttype===0 || sta.accounttype===4)?'inline-block':'none',color:'#808695'}">在线商城</router-link> -->
            <!-- <router-link to="/userstore" :style="{color:'#808695'}">在线商城</router-link> -->
            </MenuItem>
            <!-- :style="{display:showMultiScreenBtn?'inline-block':'none'}" -->
           <!--  <MenuItem name="5" style="display:'none';" v-if="!isjxt"> -->
            <MenuItem name="5" style="display:none;">
            <span  :class="actname==='5'?'activeMenu':'normalMenu'">操作手册</span>
            </MenuItem>
            <Submenu name="21" style="color:#808695" :style="{display:isShowMoreMenu?'inline-block':'none'}">
                <template slot="title">
                    <span>更多</span>
                </template>
                <MenuGroup title="解答">
                    <MenuItem name="8">
                    <span :class="actname==='8'?'activeMenu':'normalMenu'">官方解答</span>
                    </MenuItem>
                    <MenuItem name="14" v-show="!isjxt">
                    <span :class="actname==='14'?'activeMenu':'normalMenu'">AI问答</span>
                    </MenuItem>
                </MenuGroup>
                <MenuGroup title="案例">
                    <MenuItem name="9">
                    <span>涉税判例</span>
                    </MenuItem>
                    <MenuItem name="10">
                    <span>税务案例</span>
                    </MenuItem>
                </MenuGroup>
                <MenuGroup title="表单" v-show="!isjxt">
                    <MenuItem name="11">
                    <span>涉税表单</span>
                    </MenuItem>
                </MenuGroup>
                <MenuGroup title="政策优惠" v-show="!isjxt">
                    <MenuItem name="12">
                    <span>优惠匹配</span>
                    </MenuItem>
                </MenuGroup>
                <MenuGroup title="我的秘书" v-if="!isjxt">
                    <MenuItem name="3-1">
                    <router-link to="/myassistant?q_type=cloudmsg">文件提醒</router-link>
                    </MenuItem>
                    <MenuItem name="3-2">
                    <router-link to="/myassistant?q_type=cloudhistory">查询记录</router-link>
                    </MenuItem>
                </MenuGroup>
                <!-- <MenuGroup title="手册" v-if="!isjxt">
                    <MenuItem name="5">
                    <span>操作手册</span>
                    </MenuItem>
                </MenuGroup> -->
            </Submenu>
            <!--    <MenuItem name="6" :style="{display:showMultiScreenBtn?'inline-block':'none',color:'#808695',fontWeight:actname==='6'?'bold':'normal'}">
            <span>演示视频</span>
            </MenuItem> -->
        </Menu>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from '../store'
import eventBus from "../components/common/event_bus.js"
export default {
    name: 'TopMenu',
    inject: ['getSliders'],
    data() {
        return {
            res: "",
            theme1: 'dark',
            showMultiScreenBtn: true,
            isShowStore: true,
            actname: '1',
            isShowMoreMenu: false,
            isjxt:store.state.user.isjxt,
        }
    },
    computed: {
        ...mapGetters(['sta'], 'accounttype'),
        isOpenStore: function() {
            console.log(this.sta.permission.length)
            if (this.sta.permission.length > 0) {
                let index = this.sta.permission.findIndex(p => p.f === '900001')
                console.log('index:' + index)
                if (index >= 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }

            // if(this.sta.permission[12].f==='900001'){
            //     return true
            // }else{
            //     return false
            // }

        },
        // isShowStore: function() {
        //     let rlt = true
        //     let accounttype = this.sta.accounttype
        //     if (accounttype === 2 || accounttype === 3) {
        //         rlt = false
        //     }
        //     console.log('isShowStore:' + rlt)
        //     return rlt
        // }
    },
    watch: {

    },
    created() {
        //this.showTopMenuByAccountType()
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.screenwidth = document.body.clientWidth
            // console.log("screenwidth:"+this.screenwidth)
            // console.log(this.getSliders())
            if (this.getSliders().length > 0) {
                if (this.screenwidth / this.getSliders().length > 900) {
                    console.log('显示“更多”菜单')
                    this.isShowMoreMenu = true
                }
            } else {
                if (this.getSliders().length === 0) {
                    this.isShowMoreMenu = false
                    if (this.screenwidth < 910) {
                        this.isShowMoreMenu = true
                    } else {
                        this.isShowMoreMenu = false
                    }
                }

            }
        })
        eventBus.$on('open_manual', () => {
            console.log("eventBus open_manual...")
            this.onMenuSelect('5')
        })
    },
    beforeDestroy() {
        eventBus.$off('open_manual')
    },
    methods: {
        // showTopMenuByAccountType() {
        //   console.log(this.$router.history.current.name)
        //     let accounttype = this.sta.accounttype
        //     if (accounttype === 1 || accounttype === 3) {
        //         this.isShowStore = false
        //         this.$router.push('search')
        //     }
        // },
        msg (type) {
                this.$Message[type]({
                    background: true,
                    content: '涉税判例升级维护中 ···'
                });
        },
        showMultiBtn(state) {
            this.showMultiScreenBtn = state
            if (!state) {
                this.isShowMoreMenu = true
            } else {
                this.isShowMoreMenu = false
            }
        },
        onMenuSelect(value) {
            console.log('onMenuSelect:' + value)
            // console.log(this.sta)
            // console.log(this.isOpenStore)
            // console.log(this.$router.currentRoute)
            this.actname = value
            //商城
            if (value === '4') {
                if (!this.isOpenStore) {
                    this.$Message.warning("暂未开放")
                    return
                } else {
                    // var that = this
                    // this.$Modal.confirm({
                    //         title: '提示',
                    //         content: "前往在线商城，即将关闭已打开的分屏",
                    //         onOk:function() {
                    //             that.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })
                    //         },
                    //         onCancel:function() {
                    //             console.log(that.$router.currentRoute)
                    //             // that.$nextTick(function(){
                    //             //     that.$refs.menu2.$emit('on-select',value)
                    //             // })
                    //             //that.actname=value
                    //             return
                    //         },
                    // });
                    this.$router.push({ name: 'userstore', params: { tabindex: 'name1' } })
                }

            }
            //政策法规
            if (value === '1') {
                this.$router.push({ name: 'localsearch' })
            }
            //官方解答
            if (value === '8') {
                console.log("官方解答==>")
                this.$router.push({ name: 'jdsearch' })
            }
            //搜索引擎
            if (value === '7') {
                this.$router.push({ name: 'usersearch' })
            }
            //司法判例
            if (value === '9') {
                console.log("司法判例==>")
                this.$router.push({ name: 'casessearch' })
                //this.msg('info');
                return
            }
            //税务案例
            if (value === '10') {
                console.log("税务案例==>")
                this.$router.push({ name: 'taxsearch' })
            }
            //税务案例
            if (value === '13') {
                console.log("专家解读==>")
                this.$router.push({ name: 'expertsearch' })
            }
            //智能问答
            if (value === '14') {
                console.log("AI智能问答==>")
                this.$router.push({ name: 'taxchat' })
            }
            //涉税表格
            if (value === '11') {
                console.log("涉税表格==>")
                this.$router.push({ name: 'taxformsearch' })
            }
            //政策匹配
            if (value === '12') {
                console.log("政策匹配==>")
                this.$router.push({ name: 'matchfile' })
            }
            //用户手册
            if (value === '5') {
                this.$router.push({ name: 'usermanual' })
            }
            //视频
            if (value === '6') {
                this.$router.push({ name: 'uservideo' })
            }
            //风险监测
            if (value === '15') {
                console.log("风险检测==>")
                this.$router.push({ name: 'riskdetection' })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
$menu-font-size:14px;
$badge-font:50px;

#funcmenu {
    background-color:white;//菜单背景
    .ivu-menu {
        font-size: $menu-font-size;
        // font-weight: bold;
        display:block;
        margin:0 auto;
        width: 1400px;//块级元素居中需要设定块的长度
        .ivu-menu-item {
            font-size: $menu-font-size;
            // font-weight: bold;
            height: 30px;
            line-height: 30px;
            margin: 5px;
            padding-top: 0px;
        }
    }
}
#funcmenu2 {
    background-color:white;//菜单背景
    .ivu-menu {
        font-size: $menu-font-size;
        // font-weight: bold;
        display:block;
        margin:0 auto;
        width: 600px;//块级元素居中需要设定块的长度
        .ivu-menu-item {
            font-size: $menu-font-size;
            // font-weight: bold;
            height: 30px;
            line-height: 30px;
            margin: 5px;
            padding-top: 0px;
        }
    }
}
// 子菜单选中
.ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item-selected, .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item-selected:hover{
                background-color:#dedee0;
                color:red;
            }

.ivu-layout-header {
    background: #515a6e;
    padding: 0 0px !important;
    height: 64px;
    line-height: 64px;
}

.Menu {
    background-color: white;
}

.rlink {
    height: 40px;
    line-height: 40px;
    display: block;
    background-color: yellow;
}

.Submenu {
    color: gray;
}

.activeMenu {
    font-weight: bold;
    // color: #2b85e4;
    font{
        color:yellow;
    }
}
.normalChildMenu{
    color: #ed4014;
}
.activeChildMenu{
    color: yellow;
}

.normalMenu {
    font-weight: normal;
    color: #808695;
    font{
        color:red;
    }
    .fxjc{
        color:#165DFF;
        font-weight:bold;
    }
}
//菜单激活后增加背景底色
.ivu-menu-item-active{
    // padding: 5px;
    background-color: #5cadff;
    border-radius: 5px;
    color:white !important;
    height: 30px;
    line-height: 30px;
    margin: 5px;
}


//background-color: #2d8cf0 !important;


</style>
<style>
/*全局样式*/
.ivu-tooltip-inner{
    background-color: #2d8cf0 !important;
}
</style>